import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { NavLink } from "react-router-dom";
import auth from "../firebase/auth";

function Header() {
  const [user] = useAuthState(auth);

  const MenuLink = (props) => {
    return (
      <li>
        <NavLink
          className={({ isActive }) =>
            `hover:decoration-wavy hover:decoration-blue-400 hover:underline-offset-8` +
            (isActive
              ? " bg-primary hover:no-underline btn btn-primary normal-case text-lg"
              : "")
          }
          style={({ isActive }) =>
            !isActive
              ? {}
              : {
                  color: "white",
                }
          }
          {...props}
        />
      </li>
    );
  };

  const DropdownMenuLink = (props) => (
    <MenuLink className="text-lg hover:no-underline" {...props} />
  );

  const handleSignOut = async () => {
    await signOut(auth);

    localStorage.removeItem("token");
  };

  return (
    <header class="navbar bg-base-100 p-4 lg:p-6 flex justify-between gap-4">
      <div class="navbar-start gap-2 w-auto">
        <div class="dropdown">
          <label tabindex="0" class="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>

          <ul
            tabindex="0"
            class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <DropdownMenuLink to="/">Home</DropdownMenuLink>
            <DropdownMenuLink to="/blogs">Blogs</DropdownMenuLink>
            <DropdownMenuLink to="/portfolio">Portfolio</DropdownMenuLink>
          </ul>
        </div>

        <span
          class="text-4xl text-center font-black"
          style={{
            fontFamily: "Pacifico, sans-serif",
          }}
        >
          GEARS PC
        </span>
      </div>

      <div class="navbar-center hidden lg:flex w-auto">
        <ul class="menu menu-horizontal p-0">
          <MenuLink to="/blogs">Blogs</MenuLink>
          <MenuLink to="/">Home</MenuLink>
          <MenuLink to="/portfolio">Portfolio</MenuLink>
        </ul>
      </div>

      <div class="text-center navbar-end menu menu-horizontal p-0 flex-grow-0 w-auto">
        {user ? (
          <>
            <MenuLink
              to="/dashboard"
              className="text-primary hover:no-underline"
            >
              {/* couldn't show display name for newly registered user. Probably the updateProfile hook doesn't update the auth state */}
              {user.displayName || user.email}
            </MenuLink>

            <li>
              <button
                onClick={handleSignOut}
                className="text-lg hover:underline hover:decoration-wavy hover:decoration-blue-400 hover:underline-offset-8"
              >
                Log Out
              </button>
            </li>
          </>
        ) : (
          <>
            <MenuLink to="/login">Login</MenuLink>
            <MenuLink to="/register">Register</MenuLink>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;
